import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Form } from "react-bootstrap";
import CustomFormCheck from "utils/CustomFormCheck";
import CustomTooltip from "utils/CustomTooltip";
import BackButton from "./BackButton";
import NextButton from "./NextButton";
import SkipButton from "./SkipButton";
import getNextPage from "./getNextPage";
import { RouterContext } from "./Onboarding";
import { capitalize } from "lodash";
export default function TrackSpecificACtionIds(props) {
  const route = useContext(RouterContext);

  const nextPage = getNextPage(props.onboarding_progress);
  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);
  props.pageLocator();
  const sectionName = ["Search", "Display", "Video"];
  const sectionName2 = ["Search", "Display", "Video"];

  console.log(props.conversionActions.search.length)
  const [searchActive, setSearchActive] = useState(props.conversionActions.search.lengh > 0 ? false : true);
  const [displayActive, setDisplayActive] = useState(props.conversionActions.display.lengh > 0 ? false : true);
  const [videoActive, setVideoActive] = useState(props.conversionActions.video.lengh > 0 ? false : true)
  const [showBoxes, setShowBoxes] = useState(searchActive ? true : displayActive ? true : videoActive ? true : false);
  const [validated, setValidation] = useState(false);
console.log(searchActive)
  const displayHelper = (section) => {
    section = section.toLowerCase();

    if (section === "search") {
      return searchActive;
    }
    if (section === "display") {
      return displayActive;
    }
    if (section === "video") {
      return videoActive;
    }
  };
  useEffect(() => {
    if (!(searchActive || displayActive || videoActive) && showBoxes) {
      setValidation(false);
    }
  });
  const conversionActionBox = (section) => {
    const sectionKey = section.toLowerCase();

    const conversionActions = props.conversionActions[sectionKey] ? props.conversionActions[sectionKey] : [];

    const [rows, setRows] = useState(conversionActions);

    const addNewRow = () => {
      let newActions = { ...props.conversionActions };
      let newRow = {
        conversion_type: "exclusive",
        conversion_id: "",
        name: "",
      };
      newActions[sectionKey].push(newRow);
      setRows([...newActions[sectionKey]]);
      props.setConversionActions({ ...newActions });
    };

    const removeRow = (index) => {
      let newActions = { ...props.conversionActions };
      newActions[sectionKey].splice(index, 1);
      setRows([...newActions[sectionKey]]);
      props.setConversionActions({ ...newActions });
    };

    const changeRow = (index, name, value) => {
      let newActions = { ...props.conversionActions };
      newActions[sectionKey][index][name] = value;
      setRows([...newActions[sectionKey]]);
      props.setConversionActions({ ...newActions });
    };

    return (
      <Row
        style={{
          visibility: displayHelper(section) === false ? "hidden" : undefined
        }}
        className="d-flex h-a">
        <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
        <Col className="conversion-action-box  h-a" style={{backgroundColor: "#E1E1E1", margin: "0 10px"}}>
          <Row>
            <Col>
              <p className="visby-bold text-info pb-3 f18">{section}</p>
            </Col>
          </Row>
          <div className="conversion-action-scroll-box">
            {rows.map((conversionAction, idx) => {
              return (
                <Row className="pb-2 align-items-center" key={idx}>
                  <Col md={4}>
                    <Form.Control
                      className="client-drop"
                      size="sm"
                      as="select"
                      value={conversionAction.conversion_type}
                      onChange={(e) => changeRow(idx, "conversion_type", e.target.value)}>
                      <option value="exclusive">Exclude</option>
                      <option value="inclusive">Include</option>
                    </Form.Control>
                  </Col>
                  <Col md={3}>
                    <Form.Control
                      size="sm"
                      className=""
                      placeholder="Name"
                      value={conversionAction.name}
                      onChange={(e) => changeRow(idx, "name", e.target.value)}
                    />
                  </Col>
                  <Col md={3}>
                    <Form.Control
                      size="sm"
                      className=""
                      placeholder="ID"
                      value={conversionAction.conversion_id}
                      onChange={(e) => changeRow(idx, "conversion_id", e.target.value)}
                    />
                  </Col>
                  <Col>
                    <i onClick={() => removeRow(idx)} className="fas pb-1 fa-minus-circle" style={{width: "30px"}}></i>
                  </Col>
                </Row>
              );
            })}
          </div>
          <Row>
            <Col>
              <Button
                style={{
                  paddingLeft: "25px",
                  paddingRight: "24px",
                }}
                className="mt-2 btn-sm text-center"
                variant="success"
                size="sm"
                onClick={() => addNewRow()}>
                + Add
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  };

  return (
    <>
      <Row className=" mb-1  justify-content-center">
        <Col md={6}>
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">Conversion Action ID Tracking</p>
          </div>
          <div>
            <p className="f16 nunito-regular  primary ">Do you have any specific conversion action ID's to include or exclude for any PPC sub-services?</p>
          </div>
        </Col>
      </Row>

      <Row className=" mb-3 pb-3 justify-content-center">
        <Col md={6}>
          <div className="pb-2">
            <CustomTooltip
              faClass="far fa-question-circle pb-1 f16 text-info pt-1 pr-2"
              message={
                <div style={{ textAlign: "center" }}>
                  <p>
                    Sometimes, clients have multiple conversion actions for their campaigns and we only need to focus on one. As a result, sometimes we need to
                    specify which conversions to use for the "conversions" column in DataPulse. If you need to utilize a specific conversion action ID to track as
                    the success metric for a sub-service, you may enter it in here. <br></br>
                    <br></br>To get a Conversion Action ID, go to Google Ads and open the Tools & Settings menu from the top right of the navbar. In the
                    Measurement column, select Conversions. Next, select the conversion action from the list that appears. Once you have selected a conversion
                    action, check the final URL of the page and look for the 'ctId' parameter. This will be equal to the Conversion Action's ID`
                  </p>
                  <img src="https://digital-position.monday.com/protected_static/2205640/resources/991799417/large-conversion-action-ctid.jpg" alt="Conversion Aciton ID" style={{ maxWidth: "450px", display: "block", margin: "0 auto", marginTop: "10px" }}/>
                </div>
              }
              inline={true}
            />{" "}
            <span className=" f16 text-info pt-1 ">What does this mean?</span>
          </div>
          <div className="d-flex flex-column ">
            <Form.Check
              className="f16"
              name="ob-tracking"
              checked = {showBoxes == true}
              custom
              label="Yes I do."
              type="radio"
              id="ob-tracking-yes"
              onClick={() => {
                setShowBoxes(true);
                setValidation(true);
              }}
            />
            <Form.Check
              name="ob-tracking"
              className="f16"
              custom
              label="No I do not."
              type="radio"
              id="ob-tracking-no"
              onClick={() => {
                setShowBoxes(false);
                setValidation(true);
                setDisplayActive(false)
                setSearchActive(false)
                setVideoActive(false)
              }}
            />
          </div>
        </Col>
      </Row>
      <div className={showBoxes === false ? "d-none" : undefined}>
        <Row className=" pb-3  justify-content-center">
          <Col md={6}>
            <p className=" f16 nunito-regular primary ">For which sub-services?</p>
            <Row className="">
              <Col md={5}>
                <div className="my-3 ">
                  {sectionName.map((section, idx) => {
                    section = section.toLowerCase();

                    return (
                      <div key={idx} className="d-flex pb-2 justify-content-start">
                        {section === "search" ? (
                          <CustomFormCheck
                            id={`ob-${section}`}
                            name={section}
                            label={capitalize(section)}
                            checked={searchActive}
                            onChange={() => {
                              setValidation(true);
                              setSearchActive(!searchActive);
                            }}
                          />
                        ) : section === "display" ? (
                          <CustomFormCheck
                            id={`ob-${section}`}
                            name={section}
                            label={capitalize(section)}
                            checked={displayActive}
                            onChange={() => {
                              setDisplayActive(!displayActive);
                              setValidation(true);
                            }}
                          />
                        ) : section === "video" ? (
                          <CustomFormCheck
                            id={`ob-${section}`}
                            name={section}
                            label={capitalize(section)}
                            checked={videoActive}
                            onChange={() => {
                              setVideoActive(!videoActive);
                              setValidation(true);
                            }}
                          />
                        ) : undefined}
                      </div>
                    );
                  })}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col lg={9} xl={8}>
            <Row className="mt-4 ca-container">
              {sectionName2.map((section, idx) => {
                return (
                  <Col
                    style={{
                      display: showBoxes === false ? "none" : displayHelper(section) === false ? "none" : undefined,
                    }}
                    className="mb-3 conversion-action-box-outer"
                    key={idx}>
                    {conversionActionBox(section)}
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Row>
      </div>
      <Row className="mt-5 ">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
